<div id="popup">
  <dx-popup [dragEnabled]="false" [showTitle]="!!headerData" title="{{headerData}}" (onHiding)="onHiding($event)"
    [(visible)]="popUpVisible">
    <dx-scroll-view width="100%" height="100%">

      <ng-content></ng-content>
    </dx-scroll-view>
  </dx-popup>
</div>